module.exports = "https://statics.teams.cdn.live.net/hashedassets-launcher/v2/download_secondary.3c7275cf3c3cb80869c70f23783c7680.svg";